<form class="routed-component-layout" [formGroup]="form" novalidate autocomplete="off">

  <div class="routed-component-body">

    <div class="routed-component-title-block">

      <h2>{{'REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.TITLE' | translate}}</h2>
      <h5>{{'REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.SUB_TITLE' | translate}}</h5>
    </div>
    <div>
      <soldo-field-layout
        [control]="form.controls['isInternational']"
        fieldName="isInternational"
        cypressSelector="Company_RadioButton_InternationalBusiness">

        <fieldset input>
          <div class="radio-item" [attr.data-cy]="'Company_RadioButton_InternationalBusiness_DOMESTIC'">
            <input type="radio" formControlName="isInternational" id="optionDomesticOnly" [value]="false" name="isInternational">
            <label for="optionDomesticOnly">{{ "REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.OPTION_DOMESTIC_LABEL" | translate }}</label>
          </div>

          <div class="radio-item" [attr.data-cy]="'Company_RadioButton_InternationalBusiness_INTERNATIONAL'">
            <input type="radio" formControlName="isInternational" id="optionInternational" [value]="true" name="isInternational">
            <label for="optionInternational">{{ "REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.OPTION_INTERNATIONAL_LABEL" | translate }}</label>
          </div>
        </fieldset>
      </soldo-field-layout>
      <div class="conditional-subfield-container field-group-layout" *ngIf="form.controls['primaryInternationalMarket']">
        <soldo-field-layout
          [control]="form.controls['primaryInternationalMarket']"
          fieldName="primaryInternationalMarket"
          cypressSelector="Company_NgSelect_PrimaryInternationalMarket"
          label="REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.MAIN_INT_COUNTRY_LABEL">

          <ng-select input
            formControlName="primaryInternationalMarket"
            [items]="internationalCountriesList" dropdownPosition="bottom"
            notFoundText="{{'NO_ITEMS_FOUND' | translate }}"
            [clearable]=false bindLabel="name" bindValue="iso3"
            placeholder="{{ 'REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.MAIN_INT_COUNTRY_PLACEHOLDER' | translate }}"
            name="primaryInternationalMarket">
          </ng-select>

          <ng-container errorMessage>
            <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
          </ng-container>
        </soldo-field-layout>

        <div class="callout informative">
          <div class="callout-content">
            <p>{{ 'REGISTRATION.COMPANY_STEP.INTERNATIONAL_ACTIVITY.INT_COUNTRY_HELP_PARAGRAPH' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="previousStep()"
        data-cy="Signup_Button_PreviousStepButton">
        {{ 'REGISTRATION.COMPANY_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
      </button>
      <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}" (click)="nextStep()"
        data-cy="Signup_Button_NextStepButton">{{ 'REGISTRATION.COMPANY_STEP.NEXT_SUB_STEP_BUTTON' | translate }}</button>
    </div>
    <save-and-continue-later stepName="Company International Activity"></save-and-continue-later>
  </div>

</form>
